import { Flex, GapSize } from "@/components/atoms/flex";
import { Label, Text, tokens } from "@fluentui/react-components";
import React, { useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import { ItemProp } from "./types";
import { useStyle } from "./style";

export const ItemDetailsMobile = (props: {
	itemProps?: ItemProp[];
	actions?: JSX.Element[];
}) => {
	const { itemProps, actions } = props;
	const intl = useIntl();
	const classes = useStyle();

	const textWithLabel = useCallback(
		({ label, mainValue, secondaryValue }: ItemProp) => (
			<Flex column key={label}>
				<Label weight="semibold" size="small" className={classes.itemLabel}>
					{label}
				</Label>
				<Text className={classes.itemValue}>{mainValue ? mainValue : "-"}</Text>
				{secondaryValue && (
					<Text
						style={{ color: tokens.colorNeutralForeground3 }}
						size={200}
						className={classes.itemValue}
					>
						{secondaryValue}
					</Text>
				)}
			</Flex>
		),
		[]
	);

	const filterEmptyFragments = (elements: JSX.Element[]): JSX.Element[] => {
		return elements.filter((element) => {
			if (React.isValidElement(element) && element.type === React.Fragment) {
				return (
					React.Children.count(
						(element.props as { children?: React.ReactNode }).children
					) > 0
				);
			}
			return true;
		});
	};

	const filteredActions = useMemo(
		() => (actions ? filterEmptyFragments(actions) : []),
		[actions]
	);

	return (
		<Flex column gap={GapSize.Medium}>
			{itemProps?.map((x) => textWithLabel(x))}
			{filteredActions.length > 0 && (
				<>
					<Label
						weight="semibold"
						size={"small"}
						style={{ color: tokens.colorNeutralForeground3 }}
					>
						{intl.formatMessage({ id: "Interaction.Table.Actions" })}
					</Label>
					<Flex gap={GapSize.ExtraSmall}>{filteredActions?.map((x) => x)}</Flex>
				</>
			)}
		</Flex>
	);
};
